<template>
  <div class="post">
    <a-tabs class="tabs" @change="getData()" v-model="params.statuses">
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.key">
          <span slot="tab">{{ tab.text }}</span>
        </a-tab-pane>
      </template>
    </a-tabs>
    <a-row :gutter="30" style="padding-top:30px;">
      <a-col span="24" style="margin-bottom:25px;">
        <a-radio-group
            v-model="jobType"
            buttonStyle="solid"
            style="margin-right:12px;"
            @change="getData()"
        >
          <a-radio-button value="1">我的职位</a-radio-button>
          <a-radio-button value="0">全部职位</a-radio-button>
        </a-radio-group>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">发布时间</a-col>
          <a-col span="18">
            <a-range-picker style="display:block" format="YYYY-MM-DD" v-model="created_time"/>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">职能</a-col>
          <a-col span="18">
            <a-cascader
                changeOnSelect
                :options="function_id"
                v-model="params.category_id"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                placeholder="请选择职能"
                style="display:block"
                @click="getFunction_id"
            ></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">学历要求</a-col>
          <a-col span="18">
            <a-select placeholder="请选择学历" class="marriage-select" v-model="params.education_id">
              <a-select-option :value="0">不限</a-select-option>
              <a-select-option :value="1">博士</a-select-option>
              <a-select-option :value="2">MBA/EMBA</a-select-option>
              <a-select-option :value="3">硕士</a-select-option>
              <a-select-option :value="4">本科</a-select-option>
              <a-select-option :value="5">大专</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">职位名称</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入职位名称" v-model="params.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">公司名</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入公司名" v-model="params.company_name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <!--<a-col span="8" style="margin-bottom:25px;">-->
      <!--<a-row type="flex" align="top">-->
      <!--<a-col span="6" class="form-label">职位状态</a-col>-->
      <!--<a-col span="18">-->
      <!--<a-select-->
      <!--placeholder="请选择职位状态"-->
      <!--class="marriage-select"-->
      <!--v-model="params.statuses"-->
      <!--&gt;-->
      <!--<a-select-option value="1">待审核</a-select-option>-->
      <!--<a-select-option value="2">已下线</a-select-option>-->
      <!--<a-select-option value="3">暂停</a-select-option>-->
      <!--<a-select-option value="4">禁用</a-select-option>-->
      <!--</a-select>-->
      <!--</a-col>-->
      <!--</a-row>-->
      <!--</a-col>-->
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">所在城市</a-col>
          <a-col span="18">
            <a-cascader
                changeOnSelect
                :options="options"
                v-model="params.city"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                placeholder="请选择城市"
                style="display:block"
                @click="getOptions"
            ></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;" v-show="jobType == 0">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">IE</a-col>
          <a-col span="18">
            <a-auto-complete
                style="display:block"
                :dataSource="suggestion"
                @search="handleSearch"
                v-model="params.ie_user_id"
                placeholder="请输入关键字"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button type="primary" style="margin-right:12px;padding:0 30px;" @click="getData()">筛选</a-button>
        <a-button style="margin-right:12px;" @click="resetParams">清空筛选条件</a-button>
        <span>共找到 {{ total }} 条信息</span>
      </a-col>
      <!--      <a-col>-->
      <!--        <a-button-->
      <!--            type="primary"-->
      <!--            @click="Mustsee"-->
      <!--        >批量设置必看-->
      <!--        </a-button>-->
      <!--      </a-col>-->
      <a-col>
        <el-checkbox v-model="checkedAll" @change="checkAllSet">全选</el-checkbox>
        <span class="batch_set" @click="showSet">批量设置必看</span>
        <a-button
            type="primary"
            @click="addPost"
            v-if="isGranted('job_manager.job_list.btn_add_job')"
        >+ 发布职位
        </a-button>
      </a-col>
    </a-row>
    <a-row type="flex" align="middle" justify="start" class="sort-bar">
      <template v-for="sort in sorts">
        <a-col
            span="3"
            class="sort"
            :class="{ active: selectedSort.id == sort.id }"
            :key="sort.id"
            @click="changeSort(sort)"
        >
          {{ sort.name }}
          <a-icon :type="`arrow-${sort.arr}`"></a-icon>
        </a-col>
      </template>
    </a-row>
    <a-spin :spinning="loading" size="large">
      <a-row
          type="flex"
          align="middle"
          justify="start"
          class="table-con"
          @click.native="showPostInfo(item.id)"
          v-for="(item, i) in list"
          :key="i"
      >
        <el-checkbox class="position_label" v-model="item.checked" @click.native.stop
                     @change="changeSet($event,i)"></el-checkbox>
        <a-col span="6" class="post-info">
          <div class="post-name">
            <span @click.stop>{{ item.id }}</span>
            #{{ item.name }}
            <span class="ji" v-if="item.is_urgent == '1'">急</span>
            <span class="duo" v-if="item.is_mhc == '1'">多HC</span>
          </div>
          <div class="info-list">
            <span>{{ item.job_areas | formatCity }}</span>
            <a-divider type="vertical"/>
            <span>招聘{{ item.quantity }}人</span>
            <a-divider type="vertical"/>
            <span>{{ item.experience_name }}经验</span>
            <a-divider type="vertical"/>
            <span>{{ item.education_name }}</span>
          </div>
          <div class="info-list">
            <span>{{ item.second_category_name }}</span>
            <a-divider type="vertical"/>
            <span>{{ item.company.name }}</span>
          </div>
        </a-col>
        <a-col span="4">
          <div class="post-salary" v-if="item.hunter_salary_max == '0'">面议</div>
          <div class="post-salary" v-else>{{ item.hunter_salary_min }}-{{ item.hunter_salary_max }}万</div>
          <div class="salary-list" v-if="item.hunter_commission_type == '1'">
            佣金：{{ item.hunter_commission_min }}-{{
              item.hunter_commission_max
            }} （{{ item.hunter_commission_value }}%）
          </div>
          <!-- <div
            class="salary-list"
            v-if="item.hunter_commission_type == '1'"
          >佣金比例：{{ item.hunter_commission_value }}%</div>-->
          <div
              class="salary-list"
              v-if="item.hunter_commission_type == '2'"
          >佣金：{{ item.hunter_commission_max }}
          </div>
          <div class="salary-list">保证期：{{ item.probation_name }}</div>
        </a-col>
        <a-col span="6">
          <div>
            职位状态：
            <span v-if="item.status == 'OK'">招聘中</span>
            <span v-if="item.status == 'PENDING'">待审核</span>
            <span v-if="item.status == 'PAUSED'">已下线</span>
            <span v-if="item.status == 'DRAFT'">草稿职位</span>
            <span v-if="item.status == 'BLOCKED'">审核未通过</span>
          </div>
          <div class="salary-list">更新时间 ：{{ item.refreshed_at }}</div>
          <div class="salary-list">
            被浏览：{{ item.num_views }}人 被接单：{{ item.count_posts }}人
            <a-button type="link" @click.stop="downloadPostAttachment(item.id)"
                      v-if="user.uid === '1' || user.uid === '3' || user.uid === '5'">下载附件
            </a-button>
          </div>
        </a-col>
        <a-col span="4" class="operation" v-if="item.post_counts">
          <div @click.stop="GoPage('CREATED',item.id)" v-if="item.post_counts.CREATED">
            新推荐：{{ item.post_counts.CREATED }}
          </div>
          <div @click.stop="GoPage('AUDIT_PASSED',item.id)" v-if="item.post_counts.AUDIT_PASSED">
            审核通过：{{ item.post_counts.AUDIT_PASSED }}
          </div>
          <div @click.stop="GoPage2('AUDIT_FAILED',item.id)" v-if="item.post_counts.AUDIT_FAILED">
            审核不通过：{{ item.post_counts.AUDIT_FAILED }}
          </div>
          <div @click.stop="GoPage('SUBMIT_PASSED',item.id)" v-if="item.post_counts.SUBMIT_PASSED">
            推荐已过：{{ item.post_counts.SUBMIT_PASSED }}
          </div>
          <div @click.stop="GoPage2('SUBMIT_FAILED',item.id)" v-if="item.post_counts.SUBMIT_FAILED">
            推荐未通过：{{ item.post_counts.SUBMIT_FAILED }}
          </div>
          <div @click.stop="GoPage('INTERVIEW',item.id)" v-if="item.post_counts.INTERVIEW">
            面试中：{{ item.post_counts.INTERVIEW }}
          </div>
          <div @click.stop="GoPage2('INTERVIEW_FAILED',item.id)" v-if="item.post_counts.INTERVIEW_FAILED">
            面试未通过：{{ item.post_counts.INTERVIEW_FAILED }}
          </div>
          <div @click.stop="GoPage('OFFERED',item.id)" v-if="item.post_counts.OFFERED">
            发送offer：{{ item.post_counts.OFFERED }}
          </div>
          <div @click.stop="GoPage('ENTERED',item.id)" v-if="item.post_counts.ENTERED">
            已入职：{{ item.post_counts.ENTERED }}
          </div>
          <div @click.stop="GoPage2('NOT_ENTERED',item.id)" v-if="item.post_counts.NOT_ENTERED">
            未入职：{{ item.post_counts.NOT_ENTERED }}
          </div>
          <div @click.stop="GoPage('COMPLETED',item.id)" v-if="item.post_counts.COMPLETED">
            已过保：{{ item.post_counts.COMPLETED }}
          </div>
          <div @click.stop="GoPage2('NOT_COMPLETED',item.id)" v-if="item.post_counts.NOT_COMPLETED">
            未过保：{{ item.post_counts.NOT_COMPLETED }}
          </div>
          <div @click.stop="GoPage('UNSETTLED',item.id)" v-if="item.post_counts.UNSETTLED">
            待结算：{{ item.post_counts.UNSETTLED }}
          </div>
          <div @click.stop="GoPage('SETTLED',item.id)" v-if="item.post_counts.SETTLED">
            已结算：{{ item.post_counts.SETTLED }}
          </div>
          <div @click.stop="GoPage2('CLOSED',item.id)" v-if="item.post_counts.CLOSED">
            已关闭：{{ item.post_counts.CLOSED }}
          </div>
          <div @click.stop="GoPage('DELIVER',item.id)" v-if="item.post_counts.DELIVER">
            C端用户投递：{{ item.post_counts.DELIVER }}
          </div>
          <div @click.stop="GoPage2('HUNTER_REFUSE',item.id)" v-if="item.post_counts.HUNTER_REFUSE">
            猎头拒绝：{{ item.post_counts.HUNTER_REFUSE }}
          </div>
        </a-col>
        <a-col span="4" class="operation" @click.stop>
          <a-popconfirm
              title="确定审核通过？"
              @confirm="online(item.id)"
              okText="确定"
              cancelText="取消"
              v-if="
                item.status == 'PENDING' &&
                  isGranted('job_manager.job_list.audit')
              "
          >
            <div>审核通过</div>
          </a-popconfirm>
          <a-popconfirm
              title="确定审核不通过？"
              @confirm="examineRefuse(item.id)"
              okText="确定"
              cancelText="取消"
              v-if="
                item.status == 'PENDING' &&
                  isGranted('job_manager.job_list.audit')
              "
          >
            <div>审核不通过</div>
          </a-popconfirm>
          <div
              @click="announcement(item.id)"
              v-if="
                item.status != 'PENDING' &&
                  isGranted('job_manager.job_list.btn_list_case_notice')
              "
          >案情通告
          </div>
          <div>
            <span @click="goEdit(item.id)" v-if="isGranted('job_manager.job_list.btn_list_edit')">编辑</span>
            <a-divider type="vertical"/>
            <span
                @click="refreshLoad(item.id)"
                v-if="isGranted('job_manager.job_list.btn_list_refresh')"
            >刷新</span>
          </div>
          <div
              @click="postReturn(item.id)"
              v-if="
                item.status != 'PENDING' &&
                  isGranted('job_manager.job_list.btn_list_transform_job')
              "
          >转移职位
          </div>
          <a-popconfirm
              title="确定上线该职位？"
              @confirm="online(item.id)"
              okText="确定"
              cancelText="取消"
              v-if="
                item.status == 'PAUSED' &&
                  isGranted('job_manager.job_list.btn_list_publish')
              "
          >
            <div>上线</div>
          </a-popconfirm>
          <div
              v-if="
                item.status == 'OK' &&
                  isGranted('job_manager.job_list.btn_list_offline')
              "
              @click="offline(item.id)"
          >下线
          </div>
          <div
              @click="showSingleSet(item)"
          >必看好职位
          </div>
          <div
              v-if="item.must_see_position_category_ids != ''"
              @click="cancelSingleSet(item)"
          >取消必看好职位
          </div>
        </a-col>
      </a-row>
      <div class="no-data" v-if="!list.length">暂无数据</div>
    </a-spin>
    <a-row type="flex" align="middle" justify="end" :style="{ padding: '30px 0' }">
      <Pagination ref="pagination" :total="total" @change="getData"></Pagination>
    </a-row>
    <transition
        enter-active-class="animated fadeInRight"
        leave-active-class="animated fadeOutRight"
    >
      <div class="half-page" v-if="$store.state.jobHarfView" @click="toggleJobView">
        <div class="content" @click.stop>
          <a-row type="flex" justify="space-between" align="middle">
            <a-col class="close" @click="toggleJobView">
              <icon-font type="guanbi" :style="{ fontSize: '19px' }"/>
            </a-col>
            <a-col class="new_win" @click="toDetail">
              <a-icon type="fullscreen"/>
              在新窗口打开
            </a-col>
          </a-row>
          <!--<Detail :id="post_id" :tab="tab"></Detail>-->
          <Detail :id="post_id" :tab="tab"></Detail>
        </div>
      </div>
    </transition>
    <a-modal v-model="returnEmail" title="填写邮箱">
      <template slot="footer">
        <a-button key="back" @click="handleCancelReturn">取消</a-button>
        <a-button key="submit" type="primary" :loading="modelLoading" @click="returnPost">确认</a-button>
      </template>
      <div style="margin-bottom: 10px">
        <b>请填写转移人邮箱：</b>
      </div>
      <a-textarea placeholder="请填写转移人邮箱" :rows="4" v-model="userEmail"/>
    </a-modal>
    <a-modal v-model="offlineModel" title="填写下线理由">
      <template slot="footer">
        <a-button key="back" @click="offlineClose">取消</a-button>
        <a-button key="submit" type="primary" :loading="modelLoading" @click="offlineFun">确认</a-button>
      </template>
      <div style="margin-bottom: 10px">
        <b>请填写下线理由：</b>
      </div>
      <a-textarea placeholder="请填写下线理由" :rows="4" v-model="offlineReason"/>
    </a-modal>
    <el-dialog :title="mustTitle" center :visible.sync="dialogFormVisible" @close="closeSet">
      <el-form :model="setForm" @submit.native.prevent>
        <el-form-item label="职位ID" v-if="setStatus == 1">
          <el-input v-model="setForm.ids" autocomplete="off" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="选择职位可以快速添加职位id"></el-input>
        </el-form-item>
        <el-form-item :label="checkLabel+ '('+ setNum + '/4)'">
          <div>
            <el-tag
                :key="index"
                v-for="(tag,index) in dynamicTags"
                closable
                effect="dark"
                :type="tag.checked ? 'primary' : 'info'"
                @click="chooseLabels(tag,index)"
                :disable-transitions="false"
                @close="closeLabel(tag)">
              {{ tag.category_name }}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="labelVisible"
                v-model="labelVal"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="setLabels"
                @blur="setLabels"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showLabelInput">+ 自定义</el-button>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSet">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import {mapState, mapMutations, mapGetters} from "vuex";
import Api from "@/api";
import Pagination from "@/components/Pagination";
import Detail from "@/app/admin/post/detail";
import baseComponentVue from "../../../components/base-component.vue";
import "@/shared/plugins/element"

export default {
  name: "post",
  extends: baseComponentVue,
  data() {
    const sorts = [
      {name: "综合排序", id: 0, value: "multi_order_desc", arr: "down"},
      {name: "发布时间", id: 1, value: "time_order_desc", arr: "down"},
      // { name: "保证期", id: 2, value: "probation_asc", arr: "up" },
      {name: "佣金", id: 3, value: "commission_order_desc", arr: "down"},
      {name: "薪资", id: 4, value: "salary_order_desc", arr: "down"}
    ];
    return {
      checkedAll: false,//全选
      checkedArr: [],//多选选中值
      setForm: {
        ids: '',//批量id
      },
      dynamicTags: [],//标签数据
      checkedTagArr: [],//选中标签
      setStatus: 1,//设置必看好职位的方式 1批量 2单个
      labelVisible: false,
      labelVal: '',
      checkLabel: '选择标签',//label名
      setNum: 0,//设置的数量不能超过4个
      mustTitle: '批量设置',
      dialogFormVisible: false,//必看好职位标签设置弹窗的可见状态
      baseUrl: process.env.VUE_APP_BASEURL,
      jobType: "0",
      options: [],
      function_id: [],
      sorts,
      returnEmail: false,
      userEmail: "",
      offlineModel: false,
      offlineReason: "",
      tabs: [
        {
          text: "全部职位",
          key: ""
        },
        {
          text: "待审核",
          key: "DRAFT,PENDING"
        },
        {
          text: "已下线",
          key: "PAUSED"
        },
        {
          text: "审核未通过",
          key: "BLOCKED"
        },
        {
          text: "招聘中",
          key: "OK"
        }
      ],
      created_time: [],
      params: {
        job_attributes: 1,
        statuses: "",
        category_id: [],
        id: "",
        state: "",
        city: [],
        company_name: "",
        ie_user_id: ""
      },
      modelLoading: false,
      loading: false,
      listData: [],
      selectedSort: sorts[0],
      list: [],
      total: 0,
      pagination: undefined,
      tab: 1,
      post_id: "0",
      suggestion: [],
      Mustsee_data: {
        show: false
      },
      labelCol: {span: 7},
      wrapperCol: {span: 14},
      form: {
        name: '',
        lablenum: 1,
      },
      tags: [
        {
          checked: false,
          name: "1"
        },
        {
          checked: false,
          name: "123"
        },
        {
          checked: false,
          name: "asda"
        }
      ],
      inputVisible: false,
      inputValue: '',
    };
  },
  created() {
    let name = this.$route.query.companyName;
    let id = this.$route.query.id;
    if (name) {
      this.params.company_name = name;
    }
    if (id) {
      this.jobType = "1";
    }
  },
  mounted() {
    this.pagination = this.$refs.pagination;
    console.log(this.tabs);
    this.params.statuses = this.$route.query.tab || this.tabs[0].value;
    this.getData();
    this.getMustList();
  },
  computed: {
    ...mapGetters(["isGranted"]),
    ...mapState(['user'])
  },
  components: {Pagination, Detail},
  methods: {
    GoPage(type,id) {
      this.$router.push({
        path: "/order/process",
        query: {
          tab: type,
          id:id
        }
      });
    },
    GoPage2(type,id) {
      this.$router.push({
        path: "/order/closed",
        query: {
          tab: type,
          id:id
        }
      });
    },
    //显示批量设置必看
    showSet() {
      this.checkedArr = [];
      this.setForm.ids = '';
      this.setStatus = 1;
      this.list.forEach((item, index) => {
        if (item.checked) {
          this.checkedArr.push(item.id)
        }
      })
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.setForm.ids += this.checkedArr.join(',');
      })
    },
    //显示单个设置好职位
    showSingleSet(item) {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.setForm.ids = item.id;
        this.setStatus = 2;
        this.checkedArr = [];
        let arr = []
        if (item.must_see_position_category_ids != "") {
          arr = item.must_see_position_category_ids.split(',')
          console.log(arr)
          this.setNum = arr.length;
        } else {
          this.setNum = 0;
        }
        this.dynamicTags.forEach(item => {
          if (arr.includes(item.id)) {
            item.checked = true
          }
          ;
        })
      })
    },
    //确认批量设置
    async confirmSet() {
      console.log(this.setForm.ids, this.checkedTagArr);
      if (this.checkedTagArr.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择要配置的必看好职位标签!'
        });
      } else if (this.setForm.ids == '') {
        this.$message({
          type: 'warning',
          message: '请选择要配置的职位!'
        });
      } else {
        try {
          let params = {
            category_ids: this.checkedTagArr.join(','),
            ids: this.setForm.ids,
          }
          let res = await Api.post.setMustSee(params);
          this.$message({
            type: 'success',
            message: '设置成功!'
          });
          this.dialogFormVisible = false;
          this.checkedAll = false;
          this.getMustList();
          this.getData();
        } catch (e) {
        }
      }
    },
    //取消必看好职位
    cancelSingleSet(item) {
      this.$confirm('确认要取消必看好职位标记吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          ids: item.id,
        }
        let res = await Api.post.cancelMustSee(params);
        this.$message({
          type: 'success',
          message: '取消成功!'
        });
        this.getData();
      }).catch(() => {

      });
    },
    //关闭设置
    closeSet() {
      this.dialogFormVisible = false;
      this.checkedArr = [];
      this.setForm.ids = '';
      this.setNum = 0;
      this.dynamicTags.forEach((item, index) => {
        item.checked = false;
      })
    },
    //全选
    checkAllSet(val) {
      this.list.forEach((item, index) => {
        if (val) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    },
    //单选联动全选
    changeSet(val, index) {
      let temp = this.list.filter(item => !item.checked);
      temp.length > 0 ? this.checkedAll = false : this.checkedAll = true
    },
    //必看好职位列表
    async getMustList() {
      try {
        let res = await Api.post.getMustSeeList();
        res.forEach((item, index) => {
          item.checked = false;
        })
        this.dynamicTags = [...res];
        // this.setNum = this.dynamicTags.length;
      } catch (e) {
        //TODO handle the exception
      }
    },
    //移除标签
    closeLabel(tag) {
      if (tag.is_fixed == 1) {
        this.$message({
          type: 'success',
          message: '该标签为固定标签，无法删除!'
        });
      } else {
        this.$confirm('确认要移除当前职位标签么?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let params = {
            id: tag.id
          }
          let res = await Api.post.deleteMustSeeCategory(params);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getMustList()
          //this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        }).catch(() => {

        });
      }
    },
    //显示可编辑标签
    showLabelInput() {
      this.labelVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    //设置标签
    async setLabels() {
      let labelVal = this.labelVal;
      if (labelVal) {
        let type = 'info'
        let obj = {
          category_name: labelVal,
        }
        try {
          let res = await Api.post.setMustSeeCategory(obj);
          this.$message({
            type: 'success',
            message: '添加成功!'
          });
          this.getMustList()
          this.labelVisible = false;
          this.labelVal = '';
        } catch (e) {
          this.$message({
            type: 'error',
            message: '添加失败!'
          });
        }
      }
    },
    //选中标签
    chooseLabels(tag, index) {
      if (this.setNum >= 4) {
        this.dynamicTags.forEach((item, i) => {
          if (index == i) {
            item.checked = false;
          }
        })
      } else {
        this.dynamicTags.forEach((item, i) => {
          if (index == i && !item.checked) {
            item.checked = true;
          } else if (index == i && item.checked) {
            item.checked = false;
          }
        })
      }
      let data = this.dynamicTags.filter(item => item.checked);
      let temp = [];
      data.forEach(item => {
        temp.push(item.id)
      })
      this.checkedTagArr = [...temp];
      this.setNum = data.length;
    },
    handleOk() {
      this.Mustsee_data.show = false;
    },
    handleCancel() {
      this.Mustsee_data.show = false;
    },
    Mustsee() {
      this.Mustsee_data.show = true;
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      console.log(tags);
      this.tags = tags;
    },
    handleChange(checked) {
      console.log(this.tags);
      this.form.lablenum = 0
      for (let i = 0; i < this.tags.length; i++) {
        if (this.tags[i].checked) {
          this.form.lablenum++;
        }
      }
    },
    deletetag(idx) {
      this.tags.splice(idx, 1)
      console.log(this.tags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = {
        checked: false,
        name: this.inputValue
      };
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    ...mapMutations(["toggleJobView"]),
    handelStatusChange(value) {
      this.params.statuses = value;
      this.getData();
    },
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
    },
    async getFunction_id() {
      let response;
      try {
        response = await Api.common.getPostTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.function_id = response.tree;
    },
    resetParams() {
      this.created_time = [];
      let params = {
        job_attributes: 1,
        category_id: [],
        id: "",
        state: "",
        city: [],
        company_name: ""
      };
      this.params = {statuses: this.params.statuses, ...params};
    },
    changeSort(sort) {
      this.selectedSort = sort;
      console.log(sort);
      this.params.order = sort.value;
      this.getData();
    },
    //IE 搜索建议
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({name: value});
      let arr = [];
      response.forEach(item => {
        arr.push({value: item.uid, text: item.name});
      });
      this.suggestion = arr;
    },
    async getData(pagination, filters, sorter) {
      this.loading = true;
      console.log(pagination, "pagination");
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        ...this.params,
        created_start:
            this.created_time[0] && this.created_time[0].format("YYYY-MM-DD"),
        created_end:
            this.created_time[1] && this.created_time[1].format("YYYY-MM-DD"),
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        first_category_id: this.params.category_id[0],
        second_category_id: this.params.category_id[1],
        third_category_id: this.params.category_id[2],
        province_id: this.params.city && this.params.city[0],
        city_id: this.params.city && this.params.city[1],
        dist_id: this.params.city && this.params.city[2],
        ie_user_id:
            this.jobType == 1
                ? this.$store.state.user.uid
                : this.params.ie_user_id
      };
      try {
        var response = await Api.post.getPostList(params);
        this.total = +response.total;
        response.list.forEach((item, index) => {
          item.checked = false
        })
        this.list = [...response.list];
      } catch (err) {
      }
      this.loading = false;
      document.querySelector(".inner").scrollTop = 0; // 获取数据后页面滚动到顶部
    },
    showPostInfo(id) {
      console.log(id);
      this.post_id = id;
      this.toggleJobView();
    },
    announcement(id) {
      this.post_id = id;
      this.tab = 4;
      this.toggleJobView();
    },
    postReturn(id) {
      this.post_id = id;
      this.returnEmail = true;
    },
    handleCancelReturn() {
      this.returnEmail = false;
    },
    async returnPost() {
      this.modelLoading = true;
      let reg = new RegExp(
          "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (this.userEmail) {
        if (reg.test(this.userEmail)) {
          let response = await Api.post.transform({
            job_id: this.post_id,
            email: this.userEmail
          });
          if (response) {
            this.modelLoading = false;
            this.returnEmail = false;
            this.getData(this.pagination);
          }
        } else {
          this.$message.info("请正确填写邮箱！");
          this.modelLoading = false;
        }
      } else {
        this.$message.info("请填写邮箱！");
        this.modelLoading = false;
      }
    },
    toDetail() {
      this.toggleJobView();
      let resolveDRoute = this.$router.resolve({
        path: `post-detail/${this.post_id}`
      });
      window.open(resolveDRoute.href, "_blank");
    },
    addPost() {
      this.$router.push({
        path: "/post-edit",
        query: {
          type: "edit"
        }
      });
    },
    offlineClose() {
      this.offlineModel = false;
    },
    offline(id) {
      this.post_id = id;
      this.offlineModel = true;
    },
    async offlineFun() {
      this.modelLoading = true;
      let response = await Api.post.offline({
        job_id: this.post_id,
        offline_reason: this.offlineReason
      });
      if (response) {
        this.$message.info("操作成功！");
        this.modelLoading = false;
        this.offlineModel = false;
        this.getData(this.pagination);
      }
      console.log(response);
    },
    async online(id) {
      this.modelLoading = true;
      let response = await Api.post.publish({job_id: id});
      if (response) {
        this.$message.info("操作成功！");
        this.modelLoading = false;
        this.getData(this.pagination);
      }
    },
    async refreshLoad(id) {
      let response = await Api.post.refresh({ids: id});
      this.getData(this.pagination);
    },
    goEdit(id) {
      this.$router.push({
        path: "/post-edit",
        query: {
          postId: id
        }
      });
    },
    // async examine(id){
    //   this.modelLoading = true;
    //   let response = await Api.post.publish({ job_id: id });
    //   if (response) {
    //     this.$message.info("操作成功！");
    //     this.modelLoading = false;
    //     this.getData();
    //   }
    // },
    async examineRefuse(id) {
      this.modelLoading = true;
      let response = await Api.post.examineRefuse({job_id: id});
      if (response) {
        this.$message.info("操作成功！");
        this.modelLoading = false;
        this.getData(this.pagination);
      }
    },
    async downloadPostAttachment(id) {
      let {attachments} = await Api.post.getJobAttachments({job_id: id});
      console.log(attachments);
      if (!attachments.length) {
        this.$message.info("暂无附件");
        return;
      } else {
        this.downloadMuti(0, attachments);
      }
    },
    async downloadMuti(count, attachments) {
      if (attachments.length > count) {
        let attachment = attachments[count];
        count++;
        await this.downloadFile(attachment);
        this.downloadMuti(count, attachments);
      }
    },
    downloadFile(attachment) {
      return new Promise((resolve, reject) => {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 防止影响页面
        iframe.style.height = 0; // 防止影响页面
        iframe.src = this.baseUrl + '/resume/downloadAttachment?attachment_id=' + attachment.attachment_id;
        document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
        setTimeout(() => {
          iframe.remove();
        }, 60 * 1000);
        resolve();
      })
    }
  }
};
</script>

<style scoped lang="scss">
.post {
  .sort-bar {
    text-align: center;
    margin-top: 11px;
    border-radius: 3px;
    border: 1px solid rgba(228, 232, 235, 1);

    .sort {
      cursor: pointer;
      height: 58px;
      line-height: 58px;
      color: #909399;

      &.active {
        color: #5ec9ff;
      }
    }
  }

  .table-con {
    margin-top: 11px;
    border-radius: 3px;
    border-bottom: 1px solid rgba(228, 232, 235, 1);
    padding: 20px;
    text-align: left;
    cursor: pointer;
    position: relative;
  }

  .post-info {
    /*display: block;*/
    /*display: -webkit-box;*/
    /*-webkit-box-orient: vertical;*/
    /*-webkit-line-clamp: 1;*/
    /*overflow: hidden;*/
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
    /*padding-right: 20px;*/

    div {
      display: flex;
      align-items: center;
    }

    .ji {
      display: block;
      background: red;
      padding: 1px 6px;
      border-radius: 10px;
      margin-left: 10px;
      color: white;
      font-size: 10px;
      font-weight: 400;
    }

    .duo {
      display: block;
      background: deepskyblue;
      padding: 1px 6px;
      border-radius: 10px;
      margin-left: 10px;
      color: white;
      font-size: 10px;
      font-weight: 400;
    }

    .info-list {
      margin-top: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 20px;
    }

    .post-name {
      font-weight: bold;
    }
  }

  .post-salary {
    color: red;
    font-size: 19px;
  }

  .salary-list {
    margin-top: 10px;
  }

  .operation {
    padding-left: 15px;
    border-left: 1px solid rgba(228, 232, 235, 1);

    div {
      color: deepskyblue;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .marriage-select {
    width: 100%;
  }

  .half-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;

    .content {
      margin-left: 50%;
      width: 50%;
      height: 100%;
      overflow: auto;
      background: #fff;
      box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
      padding: 30px 40px;

      .close {
        cursor: pointer;
      }

      .new_win {
        cursor: pointer;
        color: #999;
        display: flex;
        align-items: center;

        .anticon {
          font-size: 16px;
          margin-right: 6px;
        }
      }
    }
  }

  .no-data {
    width: 100%;
    padding: 20px 0;
    color: #9b9b9b;
    border-bottom: 1px solid #e4e8eb;
    text-align: center;
  }

  .batch_set {
    text-decoration: underline;
    color: #35B5FE;
    margin-right: 15px;
    margin-left: 15px;
    cursor: pointer;
  }

  .position_label {
    position: absolute;
    left: 0;
    top: 0;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
    cursor: pointer !important;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
</style>
